<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-content paddingtopcls">
                    <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;margin-top: 30px;">
                        <h1>引入评估</h1>
                    </div>

                    <el-tabs v-model="activeCompany" type="card" class="company-tabs">
                        <el-tab-pane :label="currentCompany.name" :name="activeCompany">
                            <div>
                                <!-- ============ 评估表格 ============ -->
                                <table style="border-collapse: collapse;width:80%; margin-bottom: 20px;margin-top: 20px;margin-left: 60px;" cellspacing="0" border="1">
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" rowspan="3"><img src="../../../../public/assets/images/flow/agent_score.png" height="32" width="108"/></td>
                                        <td style="width: 180px" colspan="2" rowspan="3" class="title">海尔生物医疗经销商引入评估</td>
                                        <td style="width: 100px">编号：GNSCB-02-F01</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">版本：B</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">页次：1/1</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" colspan="4" class="subheading">基础信息</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">区    域</td>
                                        <td style="width: 180px">{{bscUserInfoAgent.areaname}}</td>
                                        <td style="width: 100px">申请日期</td>
                                        <td style="width: 100px">{{bscUserInfoAgent.creationDate}}</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">公司名称</td>
                                        <td style="width: 180px">{{bscUserInfoAgent.username}}</td>
                                        <td style="width: 100px">法人代表</td>
                                        <td style="width: 100px">{{bscUserInfoAgent.legal}}</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">对接人</td>
                                        <td style="width: 180px">{{bscUserInfoAgent.name1}}</td>
                                        <td style="width: 100px">联系电话</td>
                                        <td style="width: 100px">{{bscUserInfoAgent.contactmobilephone}}</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">对阵地市（个数）</td>
                                        <td style="width: 180px">{{bscUserInfoAgent.againstAreaCount}}</td>
                                        <td style="width: 100px">对阵用户（个数）</td>
                                        <td style="width: 100px">{{bscUserInfoAgent.againstUserCount}}</td>
                                    </tr>

                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" colspan="4" class="subheading">引入评估项目</td>
                                    </tr>
                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" class="subheading">评估项目</td>
                                        <td style="width: 180px" class="subheading">项目描述</td>
                                        <td style="width: 100px" class="subheading">见证资料（附件为必传项）</td>
                                        <td style="width: 100px" class="subheading">合格/不合格</td>
                                    </tr>

                                    <tr v-for="(item, idx) in currentCompany.items" :key="idx"
                                        style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px">{{item.name}}</td>
                                        <td style="width: 180px">{{item.desc}}</td>
                                        <td style="width: 100px">{{item.evidence}}</td>
                                        <td style="width: 100px">
                                            <el-select v-model="bscUserInfoAgent[item.field]" placeholder="请选择" disabled
                                                       class="select" style="width:100px;border: none;box-shadow: none">
                                                <el-option label="合格" value="1"></el-option>
                                                <el-option label="不合格" value="2"></el-option>
                                            </el-select>
                                        </td>
                                    </tr>

                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" class="subheading">结论</td>
                                        <td style="width: 180px" colspan="3">{{bscUserInfoAgent.conclusion}}</td>
                                    </tr>

                                    <tr style="background-color: White; text-align: center; color:black;height:30px;" v-if="!isQualified">
                                        <td style="width: 100px" class="subheading">申请请示报告</td>
                                        <td style="width: 100px" colspan="3">
                                            <brupload
                                                    :refid="refid"
                                                    :reftype="reportReftype"
                                                    uploadflag
                                                    delflag
                                                    :before-upload="beforeUpload"
                                                    :showtime="false">
                                            </brupload>
                                        </td>
                                    </tr>

                                    <tr style="background-color: White; text-align: center; color:black;height:30px;">
                                        <td style="width: 100px" class="subheading">网络运营经理确认</td>
                                        <td style="width: 180px">{{bscUserInfoAgent.quyuConfirm}}</td>
                                        <td style="width: 100px" class="subheading">省区经理确认</td>
                                        <td style="width: 100px" colspan="2">{{bscUserInfoAgent.daquConfirm}}</td>
                                    </tr>
                                </table>

                                <!-- ============ 上传附件：两列网格，自动换行 ============ -->
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin:0 0 20px 0;">
                                        <h1>上传附件</h1>
                                    </div>
                                    <div style="font-size: 0.15rem;color: #ff2424;margin-bottom: 0.2rem">
                                        * 上传文件格式只能是 JPG或PNG或PDF 格式! 文件大小不能超过 5M!
                                    </div>
                                    <div class="h-formLine">
                                        <div class="h-pieceCon2 weekplandetail30">
                                            <el-form :model="bscUserInfoAgent"
                                                     ref="formLabelAlign1i"
                                                     :inline="true"
                                                     :rules="rules"
                                                     class="upload-form"
                                                     style="margin-left: 100px">
                                                <el-form-item
                                                        v-for="(up, idx) in currentCompany.uploads"
                                                        :key="idx"
                                                        :label="up.label"
                                                        class="h-elformWrap-2 upload-cell"
                                                        :prop="up.prop">
                                                    <brupload
                                                            :refid="refid"
                                                            :reftype="resolveReftype(up.rawReftype)"
                                                            :uploadflag="false"
                                                            :delflag="false"
                                                            :before-upload="beforeUpload"
                                                            :showtime="false"
                                                            :tpFlag="true">
                                                    </brupload>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>

                    <div class="h-table h-mrt30 bbbb">
                        <div class="h-pieceTitle2 hang">
                            <h1 class="h1">审批意见</h1>
                            <el-form :model="bscUserInfoAgent" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
                                <el-form-item label="审批意见" class="h-elformWrap-2 newBox" style="width: 100%!important;">
                                    <el-input v-model="bscUserInfoAgent.auditMind2" placeholder="请输入"></el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>

                    <div class="center" style="margin-left: 300px;margin-top: 50px">
                        <el-row>
                            <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">返回</el-button>
                            <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)">驳回</el-button>
                            <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>
                            <el-button class="h-btn h-bBtn" @click="findDetail">跟踪</el-button>
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="choose1">导出Excel</el-button>
                        </el-row>
                    </div>
                    <div style="height: 50px">
                        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from "../../../api/SystemService";
    import scoretablesp from '../../../components/score/scoreShenPi'
    import updownfile from "../../../utils/updownfile";

    const COMPANY_CONFIG = {
        biomed: {
            key: 'biomed',
            name: '生物医疗',
            reftypePrefix: '',
            reportReftype: '申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '员工6名以上，一线销售人员3名以上', evidence: '提供公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '上年度销售业绩：A类区域≥1200万，B类区域≥1000万，C类区域≥600万', evidence: '提供上年度审计表' },
                { field: 'qualification', name: '经营资质', desc: '临床检验分析仪器、二类6858-3、6853-4、11-01、22-14、22-15、22-16三类6854-1、22-16', evidence: '提供营业执照、经营许可证' },
                { field: 'brandPower', name: '品牌能力', desc: '同行业相关产品的代理授权书或证书', evidence: '提供同行业品牌授权文件' },
                { field: 'businessPower', name: '业务能力', desc: '近两年中标业绩证明或合同证明10份以上，或用户合同规模≥600万', evidence: '提供合同或业绩证明文件' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '上年度审计表', rawReftype: '公司资产负债表', prop: 'upload2' },
                { label: '同行业品牌授权文件', rawReftype: '同行业品牌授权文件', prop: 'upload3' },
                { label: '合同或业绩证明文件', rawReftype: '合同或业绩证明文件', prop: 'upload4' },
                { label: '二类备案表', rawReftype: '二类备案表', prop: 'upload5' },
                { label: '三类医疗器械许可证', rawReftype: '三类医疗器械许可证', prop: 'upload6' },
            ],
        },

        blood: {
            key: 'blood',
            name: '数智血液',
            reftypePrefix: 'blood_',
            reportReftype: 'blood_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '总员工≥3人，专职血液产品销售≥1人', evidence: '公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '上年度销售业绩：A类≥600万，B类≥400万，C类≥200万', evidence: '财务报表 / 代理协议 / 项目资料' },
                { field: 'qualification', name: '经营资质', desc: '二类6858-3、6853-4、11-01、22-14、22-15、22-16', evidence: '仓库照片 / 营业执照' },
                { field: 'brandPower', name: '品牌能力', desc: '同行业相关产品的经销授权书或证书', evidence: '历史销售合同或供货证明' },
                { field: 'businessPower', name: '业务能力', desc: '近两年同行业中标合同5个用户以上，或单用户合同≥50万', evidence: '历史销售合同或供货证明' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '公司财务报表', rawReftype: '公司财务报表', prop: 'upload2' },
                { label: '传统代理商代理协议', rawReftype: '传统代理商代理协议', prop: 'upload3' },
                { label: '提供项目资料', rawReftype: '提供项目资料', prop: 'upload4' },
                { label: '仓库照片', rawReftype: '仓库照片', prop: 'upload5' },
                { label: '营业执照', rawReftype: '营业执照', prop: 'upload6' },
                { label: '历史销售合同或供货证明', rawReftype: '历史销售合同或供货证明', prop: 'upload7' },
            ],
        },

        sanda: {
            key: 'sanda',
            name: '三大',
            reftypePrefix: 'sanda_',
            reportReftype: 'sanda_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '总员工≥3人，专职血液产品销售≥1人', evidence: '公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '上年度销售业绩：A类≥600万，B类≥400万，C类≥200万', evidence: '财务报表 / 代理协议 / 项目资料' },
                { field: 'qualification', name: '经营资质', desc: '二类6858-3、6853-4、11-01、22-14、22-15、22-16', evidence: '仓库照片 / 营业执照' },
                { field: 'brandPower', name: '品牌能力', desc: '同行业相关产品的经销授权书或证书', evidence: '历史销售合同或供货证明' },
                { field: 'businessPower', name: '业务能力', desc: '近两年同行业中标合同5个用户以上，或单用户合同≥50万', evidence: '历史销售合同或供货证明' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '公司财务报表', rawReftype: '公司财务报表', prop: 'upload2' },
                { label: '传统代理商代理协议', rawReftype: '传统代理商代理协议', prop: 'upload3' },
                { label: '提供项目资料', rawReftype: '提供项目资料', prop: 'upload4' },
                { label: '仓库照片', rawReftype: '仓库照片', prop: 'upload5' },
                { label: '营业执照', rawReftype: '营业执照', prop: 'upload6' },
                { label: '历史销售合同或供货证明', rawReftype: '历史销售合同或供货证明', prop: 'upload7' },
            ],
        },

        jinweixin: {
            key: 'jinweixin',
            name: '金卫信',
            reftypePrefix: 'jinweixin_',
            reportReftype: 'jinweixin_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '员工2人以上，至少一人专职疾控渠道销售', evidence: '公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '上年销售业绩≥50万', evidence: '年度审计报告或其他收入证明材料' },
                { field: 'qualification', name: '经营资质', desc: '经营范围含6858二类；备货垫资能力，首笔货款20万以上', evidence: '销售资质' },
                { field: 'brandPower', name: '品牌能力', desc: '协助组织产品推广活动，每年≥1次', evidence: '——' },
                { field: 'businessPower', name: '业务能力', desc: '近两年疾控中心或预防接种门诊销售业绩≥2份', evidence: '历史销售合同或供货证明' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '年度审计报告或其他收入证明材料', rawReftype: '年度审计报告或其他收入证明材料', prop: 'upload2' },
                { label: '销售资质', rawReftype: '销售资质', prop: 'upload3' },
                { label: '历史销售合同或供货证明', rawReftype: '历史销售合同或供货证明', prop: 'upload4' },
            ],
        },

        kangsheng: {
            key: 'kangsheng',
            name: '康盛',
            reftypePrefix: 'kangsheng_',
            reportReftype: 'kangsheng_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '总员工≥2人，专职耗材销售≥1人', evidence: '公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '签约耗材/白标上年总销售≥200万；传统代理商为海尔签约代理商；项目类无限制', evidence: '财务报表 / 代理协议 / 项目资料' },
                { field: 'qualification', name: '经营资质', desc: '具备耗材仓储能力；营业执照经营范围含对应耗材类目', evidence: '仓库照片 / 营业执照' },
                { field: 'brandPower', name: '品牌能力', desc: '有实验室耗材、医疗耗材、生命科学产品销售经验', evidence: '历史销售合同或供货证明' },
                { field: 'businessPower', name: '业务能力', desc: '有实验室耗材、医疗耗材、生命科学产品销售经验', evidence: '历史销售合同或供货证明' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '公司财务报表', rawReftype: '公司财务报表', prop: 'upload2' },
                { label: '传统代理商代理协议', rawReftype: '传统代理商代理协议', prop: 'upload3' },
                { label: '提供项目资料', rawReftype: '提供项目资料', prop: 'upload4' },
                { label: '仓库照片', rawReftype: '仓库照片', prop: 'upload5' },
                { label: '营业执照', rawReftype: '营业执照', prop: 'upload6' },
                { label: '历史销售合同或供货证明', rawReftype: '历史销售合同或供货证明', prop: 'upload7' },
            ],
        },

        haishengjie: {
            key: 'haishengjie',
            name: '海盛杰',
            reftypePrefix: 'haishengjie_',
            reportReftype: 'haishengjie_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '员工3名及以上，一线销售人员1名及以上', evidence: '个税证明或公司社保参保人数' },
                { field: 'scale', name: '公司规模', desc: '上年销售业绩≥100万；项目类无特殊限制', evidence: '财务报表或年度审计报告 / 项目资料' },
                { field: 'qualification', name: '经营资质', desc: '经营范围含医疗器械等设备；医疗渠道含二类22-15；气体公司及oem无限制', evidence: '营业执照、经营许可证' },
                { field: 'brandPower', name: '品牌能力', desc: '低温设备、液氮生物容器、实验室设备、低温配件仪表销售经验', evidence: '合同或业绩证明文件' },
                { field: 'businessPower', name: '业务能力', desc: '低温设备、液氮生物容器、实验室设备、低温配件仪表销售经验', evidence: '合同或业绩证明文件' },
            ],
            uploads: [
                { label: '个税证明或公司社保参保人数', rawReftype: '个税证明或公司社保参保人数', prop: 'upload1' },
                { label: '财务报表或公司年度审计报告', rawReftype: '财务报表或公司年度审计报告', prop: 'upload2' },
                { label: '提供项目资料', rawReftype: '提供项目资料', prop: 'upload3' },
                { label: '营业执照、经营许可证', rawReftype: '营业执照经营许可证', prop: 'upload4' },
                { label: '合同或业绩证明文件', rawReftype: '合同或业绩证明文件', prop: 'upload5' },
            ],
        },

        houhong: {
            key: 'houhong',
            name: '厚宏',
            reftypePrefix: 'houhong_',
            reportReftype: 'houhong_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: 'A类≥6人专职≥3；B类≥4人专职≥2；C类≥3人专职≥1；D类≥2人专职≥1', evidence: '个税证明或公司社保参保人数' },
                { field: 'scale', name: '公司规模', desc: 'A类≥600万；B类>200万；C类>50万；D类不作考核', evidence: '审计报告/财务报表/业绩证明，D类提供经营说明' },
                { field: 'qualification', name: '经营资质', desc: '成立1年以上无失信；含医疗器械备案/许可证；具备仓储售后场所与垫资能力', evidence: '营业执照 / 备案或许可证 / 场所照片 / 资金证明' },
                { field: 'brandPower', name: '品牌能力', desc: '药房自动化、智慧药房、医院信息化、自动化设备相关销售实施经验', evidence: '合同或业绩证明文件' },
                { field: 'businessPower', name: '业务能力', desc: '按等级承诺年度任务与推广计划，承诺不窜货不乱价', evidence: '合同、中标证明、项目资料、推广计划' },
            ],
            uploads: [
                { label: '个税证明或公司社保参保人数', rawReftype: '个税证明或公司社保参保人数', prop: 'upload1' },
                { label: '年度审计报告/财务报表/业绩证明', rawReftype: '年度审计报告或财务报表或销售业绩证明', prop: 'upload2' },
                { label: '基本经营情况说明', rawReftype: '基本经营情况说明或相关证明材料', prop: 'upload3' },
                { label: '营业执照', rawReftype: '营业执照', prop: 'upload4' },
                { label: '医疗器械经营备案凭证或经营许可证', rawReftype: '医疗器械经营备案凭证或经营许可证', prop: 'upload5' },
                { label: '仓库或服务场所照片', rawReftype: '仓库或服务场所照片', prop: 'upload6' },
                { label: '纳税证明或资金能力证明', rawReftype: '纳税证明或相关资金能力证明', prop: 'upload7' },
                { label: '合同/中标证明/供货证明/项目资料', rawReftype: '合同中标证明供货证明项目合作资料', prop: 'upload8' },
            ],
        },

        yuanxi: {
            key: 'yuanxi',
            name: '元析',
            reftypePrefix: 'yuanxi_',
            reportReftype: 'yuanxi_申请请示报告',
            items: [
                { field: 'staffing', name: '人员配置', desc: '总员工≥2人，有销售人员，相关教育背景优先', evidence: '公司缴纳社保人员数量' },
                { field: 'scale', name: '公司规模', desc: '上年销售业绩＞100万', evidence: '年度审计报告或其他收入证明材料' },
                { field: 'qualification', name: '经营资质', desc: '成立1年以上，无失信被执行、重大处罚、经营异常', evidence: '营业执照 / 企查查天眼查失信记录' },
                { field: 'brandPower', name: '品牌能力', desc: '分析仪器、科研仪器销售经验；政府实验室、高校、检测、环境、食品制药客户资源', evidence: '中标通知书 / 政府采购网信息 / 推广案例' },
                { field: 'businessPower', name: '业务能力', desc: '承诺不窜货、不乱价，遵守厂家价格体系', evidence: '历史销售合同或供货证明（非强制）' },
            ],
            uploads: [
                { label: '公司缴纳社保人员数量', rawReftype: '公司缴纳社保人员数量', prop: 'upload1' },
                { label: '年度审计报告或其他收入证明材料', rawReftype: '年度审计报告或其他收入证明材料', prop: 'upload2' },
                { label: '营业执照', rawReftype: '营业执照', prop: 'upload3' },
                { label: '企查查/天眼查失信记录', rawReftype: '企查查或天眼查失信', prop: 'upload4' },
                { label: '中标通知书/政府采购网信息/推广案例', rawReftype: '招投标中标通知书或政府采购网中标信息', prop: 'upload5' },
                { label: '历史销售合同或供货证明', rawReftype: '历史销售合同或供货证明', prop: 'upload6' },
            ],
        },
    };

    // 后端可能用的公司字段名，按顺序取第一个非空
    const COMPANY_FIELD_CANDIDATES = ['companySco', 'company', 'companyName', 'scoCompany', 'companyBas'];

    const COMPANY_ALIAS = {
        biomed: 'biomed',
        xueye: 'xueye',
        jinweixin: 'jinweixin',
        kangsheng: 'kangsheng',
        haishengjie: 'haishengjie',
        houhong: 'houhong',
        yuanxi: 'yuanxi',
        sanda: 'sanda',

        '生物医疗': 'biomed',
        '海尔生物医疗': 'biomed',
        '数智血液': 'xueye',
        '金卫信': 'jinweixin',
        '康盛': 'kangsheng',
        '海盛杰': 'haishengjie',
        '厚宏': 'houhong',
        '元析': 'yuanxi',
        '三大': 'sanda',
    };

    function pickCompanyRaw(msg) {
        if (!msg) return '';
        for (let i = 0; i < COMPANY_FIELD_CANDIDATES.length; i++) {
            const v = msg[COMPANY_FIELD_CANDIDATES[i]];
            if (v != null && String(v).trim() !== '') return v;
        }
        return '';
    }

    function normalizeCompany(raw) {
        if (raw == null || raw === '') return 'biomed';
        const str = String(raw).trim();
        if (COMPANY_CONFIG[str]) return str;
        const lower = str.toLowerCase();
        for (const alias in COMPANY_ALIAS) {
            if (alias.toLowerCase() === lower) return COMPANY_ALIAS[alias];
        }
        for (const alias in COMPANY_ALIAS) {
            if (str.indexOf(alias) !== -1) return COMPANY_ALIAS[alias];
        }
        console.warn('【未识别的companySco】原始值=', JSON.stringify(raw), '，msg全部字段=', Object.keys(msg || {}));
        return 'biomed';
    }

    export default {
        components: { scoretablesp },
        data() {
            return {
                instid: null,
                activeCompany: 'biomed',
                rawCompany: '',
                showTaskList: false,
                usercode: "",
                bscUserInfoAgent: {
                    usercode: "", customerName1: "", staffing: "", scale: "", qualification: "",
                    brandPower: "", businessPower: "", conclusion: "", daquConfirm: "", quyuConfirm: "",
                    areaname: "", creationDate: "", username: "", legal: "", name1: "",
                    contactmobilephone: "", showscoretable: true, refid: "",
                    againstAreaCount: "", againstUserCount: "", field: "2", company: "", auditMind2: "",
                },
                refid: null,
                guancha: false,
                isQualified: false,
                showhistory: false,
                field: 2,
                inst: { daqu: "", quyu: "" },
                rules: {
                    upload1: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload2: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload3: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload4: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload5: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload6: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload7: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                    upload8: [{ required: true, message: '请上传资料', trigger: 'blur' }],
                },
            };
        },

        computed: {
            currentCompany() {
                const key = normalizeCompany(this.activeCompany);
                return COMPANY_CONFIG[key] || COMPANY_CONFIG.biomed;
            },
            reportReftype() {
                return this.currentCompany.reportReftype || '申请请示报告';
            },
        },

        methods: {
            resolveReftype(rawReftype) {
                const prefix = this.currentCompany.reftypePrefix || '';
                return prefix + rawReftype;
            },

            choose1() {
                updownfile.down('/api/swyl/v1/agent/bscUserInfoAgent/getExcel', this.bscUserInfoAgent, "post");
            },

            beforeUpload(file) {
                const isFile = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
                const isLt5M = file.size / 1024 / 1024 < 5;
                if (!isFile) {
                    this.$message.error('上传文件的格式只能是 JPG或PNG或PDF 格式!');
                    return false;
                }
                if (!isLt5M) {
                    this.$message.error('上传文件的大小不能超过 5M!');
                    return false;
                }
                return true;
            },

            getConclusion() {
                const items = this.currentCompany.items || [];
                let allPass = true;
                for (let i = 0; i < items.length; i++) {
                    if (this.bscUserInfoAgent[items[i].field] != 1) {
                        allPass = false;
                        break;
                    }
                }
                this.bscUserInfoAgent.conclusion = allPass ? "合格" : "不合格";
                this.isQualified = allPass;
            },

            pass(aaa) {
                let query = {
                    taskid: this.$route.query.taskid,
                    aaa: aaa,
                    auditMind2: this.bscUserInfoAgent.auditMind2,
                    usercode: this.bscUserInfoAgent.usercode,
                    instid: this.$route.query.instid,
                    ywid: this.$route.query.ywid,
                    company: this.bscUserInfoAgent.company,
                };
                ss.SignService.scorePass(query).then(() => {
                    this.$msg.alerts("提交成功！", () => {
                        this.$store.dispatch("searchTasktotal");
                        this.$router.push({ path: '/personal/dealCenter' });
                    });
                });
            },

            findDetail() {
                this.showhistory = true;
                this.$forceUpdate();
            },

            cancel() {
                this.$router.push({ path: '/agent/agentCopy' });
            },
        },

        created() {
            this.instid = this.$route.query.instid;

            ss.SignService.selectScoreByInstid(this.instid)
                .then(res => {
                    console.log("11111", res);
                    const msg = res.msg || {};
                    console.log('msg全部字段=', Object.keys(msg));

                    this.rawCompany = pickCompanyRaw(msg);
                    console.log('【公司原始值】=', this.rawCompany);

                    this.activeCompany = normalizeCompany(this.rawCompany);
                    this.bscUserInfoAgent.company = this.rawCompany;
                    console.log('【匹配到的公司】=', this.activeCompany);

                    this.bscUserInfoAgent.usercode = msg.usercodeInfo;
                    this.bscUserInfoAgent.customerName1 = msg.customerName1Bas;
                    this.bscUserInfoAgent.staffing = msg.staffingSco;
                    this.bscUserInfoAgent.scale = msg.scaleSco;
                    this.bscUserInfoAgent.qualification = msg.qualificationSco;
                    this.bscUserInfoAgent.brandPower = msg.brandPowerSco;
                    this.bscUserInfoAgent.businessPower = msg.businessPowerSco;
                    this.bscUserInfoAgent.conclusion = msg.conclusionSco;
                    this.bscUserInfoAgent.daquConfirm = msg.daquConfirmSco;
                    this.bscUserInfoAgent.quyuConfirm = msg.quyuConfirmSco;
                    this.bscUserInfoAgent.status = msg.statusSco;
                    this.bscUserInfoAgent.instid = msg.instidSco;
                    this.bscUserInfoAgent.areaname = msg.areanameInfo;
                    this.bscUserInfoAgent.creationDate = msg.creationDateBas;
                    this.bscUserInfoAgent.username = msg.usernameInfo;
                    this.bscUserInfoAgent.legal = msg.legalBas;
                    this.bscUserInfoAgent.name1 = msg.name1Bas;
                    this.bscUserInfoAgent.contactmobilephone = msg.contactmobilephoneBas;

                    this.refid = msg.fileidInfo;
                    this.bscUserInfoAgent.refid = msg.fileidInfo;
                    this.bscUserInfoAgent.field = 2;

                    this.$nextTick(() => {
                        this.getConclusion();
                    });
                });
        },
    }
</script>

<style>
    .showflowDialogcls .el-dialog__body { padding-top: 0px!important; }
    ::v-deep .select { border: none; box-shadow: none; }
    .company-tabs { margin-top: 10px; }

    /* 附件两列网格：每个表单项占一半宽，自动换行 */
    ::v-deep .upload-form .el-form-item {
        width: 50%;
        margin-right: 0;
        margin-bottom: 18px;
    }
</style>

<style scoped>
    .h-content { padding: 0rem 0.1rem 0 0.1rem; }
    .title { font-size: 20px; font-weight: bold; }
    .subheading { font-weight: bold; }
</style>
